import React, { useState, useEffect } from 'react';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { Icon } from '@material-ui/core';
import { stopProp } from '../../utils';
import { size } from '../../lib/lodash';
import { useScreen } from '../../styles';

// a little function to help us with reordering the result
const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);

  return result;
};

const getItemStyle = (isDragging, draggableStyle) => ({
  userSelect: 'none',
  position: 'relative',

  background: isDragging ? 'rgba(0,0,0,0.1)' : undefined,
  borderRadius: 5,

  ...draggableStyle,
});

const getListStyle = ({ isDraggingOver, isMobile, ...props }) => ({
  display: !isMobile && !props.verticalOnly ? 'flex' : 'block',
  flexDirection: !isMobile && !props.verticalOnly ? 'row' : 'column',
  flexWrap: 'wrap',
});

export const SortableList = (props) => {
  const [items, setItems] = useState(props.items);
  const { isMobile } = useScreen();

  const onDragEnd = (result) => {
    // dropped outside the list
    if (!result.destination) {
      return;
    }

    const _items = reorder(items, result.source.index, result.destination.index);

    props.onSort && props.onSort(_items);
  };

  useEffect(() => {
    setItems(props.items);
  }, [props.items]);

  return (
    <DragDropContext onDragEnd={onDragEnd}>
      <Droppable droppableId="droppable">
        {(provided, snapshot) => (
          <div {...provided.droppableProps} ref={provided.innerRef} style={getListStyle({ ...props, isDraggingOver: snapshot.isDraggingOver, isMobile })} onClick={size(items) ? stopProp : undefined}>
            {items.map((item, index) => (
              <Draggable key={item.key} draggableId={item.key} index={index}>
                {(provided, snapshot) => (
                  <div ref={provided.innerRef} {...provided.draggableProps} style={getItemStyle(snapshot.isDragging, provided.draggableProps.style)} onClick={stopProp}>
                    <div style={{ marginLeft: 26 }}>{typeof item.content === 'function' ? item.content() : item.content}</div>
                    <div {...provided.dragHandleProps} onClick={stopProp} style={{ position: 'absolute', left: 0, top: 16 }}>
                      <Icon>drag_indicator</Icon>
                    </div>
                  </div>
                )}
              </Draggable>
            ))}
            {provided.placeholder}
          </div>
        )}
      </Droppable>
    </DragDropContext>
  );
};

export default SortableList;
